import SystemMessage from '@/core/components/messages/SystemMessage/SystemMessage';

export default SystemMessage;
